import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#6F3C8D",
        },
        secondary: {
          main: "#00C4A7",
        },
        error: {
          main: "#E74C3C",
        },
        success: {
          main: "#00C4A7",
          contrastText: "#FFFFFF",
        },
        warning:{
          main: '#FFDC7D',
        }
      },
    },
  },
});
